const StatCard = ({ title, value, icon: Icon, children }) => {
    return (
        <div className="group relative overflow-hidden rounded-2xl border border-gray-100 bg-white transition-all duration-300 hover:border-brand-200 hover:shadow-xl hover:shadow-brand-500/5 dark:border-gray-800 dark:bg-white/[0.02] md:p-6">
            <div className="relative z-10 flex items-start justify-between">
                
                <div>
                    <p className="text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">
                        {title}
                    </p>
                    <h4 className="mt-2 text-xl font-extrabold tracking-tight text-gray-900 dark:text-white">
                        {value}
                    </h4>
                </div>
                <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand-50 text-brand-500 transition-all duration-300 group-hover:scale-110 group-hover:bg-brand-500 group-hover:text-white dark:bg-brand-500/10 dark:text-brand-400">
                    {Icon && <Icon className="h-6 w-6" />}
                </div>
            </div>

            {children && (
                <div className="relative z-10 mt-4 animate-in fade-in slide-in-from-bottom-2 duration-500">
                    {children}
                </div>
            )}

            {/* Subtle bottom line reflecting brand color */}
            <div className="absolute bottom-0 left-0 h-0.5 w-0 bg-brand-500 transition-all duration-500 group-hover:w-full" />
        </div>
    );
};

export default StatCard;
